
























import {Component, Vue} from "vue-property-decorator";
import myCard from "./components/solutionCard.vue";
import myTitle from "./components/myTitle.vue";

@Component({
  components: {
    myTitle,
    myCard
  },
})

export default class workService extends Vue {

  path = 'assets/solution/workService/';

  cardContent = [
    {src:this.path+'xiaolv.png',title:'服务团队效率低',text:'商用显示设备脆弱易受损，是企业的门面招牌，若不能及时处理将会导致企业的业务无法正常进行，同时影响企业的对外宣传和企业形象等问题',offset:2},
    {src:this.path+'beijian.png',title:'备件管理不科学',text:'没有制定科学的备件管理计划，导致需要维修时备件缺货，临时调度成本高且影响设备维修进度',offset:1},
    {src:this.path+'baoxiu.png',title:'报修渠道太单一',text:'传统电话报修效率低，很难全面了解企业提供的服务内容，客户体验差',offset:1},
    {src:this.path+'jindu.png',title:'服务进度不明确',text:'服务状况难以跟进，服务商没有成熟的管理系统，不清楚售后服务是否按企业要求的标准进行，容易与客户产生争议，影响企业口碑',offset:2},
    {src:this.path+'jifei.png',title:'计费方式不合理',text:'服务商计费方式单一，企业不能根据自身需要的售后情况选择计费方式，增加了企业售后服务成本',offset:1},
    {src:this.path+'weihu.png',title:'维护历史难追溯',text:'设备维护的历史情况没有备案或者很难查询，管理方式不科学、不合理',offset:1},
  ];

  solutions = [
    {
      title:'灵活的计费方式',text:'平台提供多种计费方式，用户可选择台/年计费、人/天计费或是单次计费，根据需求进行选择，帮助企业节省售后成本'
    },
    {
      title:'多渠道快速售后处理',text:'平台支持APP、微信、二维码、网页、电话等多种方式提交服务请求，系统统一处理工单，服务人员将第一时间接单，快速响应，及时处理'
    },
    {
      title:'售后进度实时跟踪',text:'平台将实时更新工单情况，消息可通过短信、手机app、微信等多种方式通知用户，让您全程掌握售后信息，轻松进行售后管理'
    },
    {
      title:'科学化备件管理',text:'平台提供备件管理功能，让用户明确每一个备件的动向，通过对备件使用情况的多维度分析，制定出科学的备件管理计划'
    },
  ]
}
